export default __webpack_public_path__ + "static/media/logo.00b7c613.svg";